module.exports = __webpack_public_path__ + "static/img/ent-detail-84.0ac84d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-84.jpg
// module id = XDI+
// module chunks = 51